import apiUrl from '../../../constants'
import axios from 'axios'
import VueElementLoading from 'vue-element-loading';
import { BasicSelect, ModelSelect } from 'vue-search-select';
import DatePicker from 'vue2-datepicker';
import moment from 'moment'
import download from 'downloadjs';

export default {
  name: 'DlinkReport',
  components: {
    VueElementLoading,
    BasicSelect,
    ModelSelect,
    DatePicker,
    download
  },
  props: [],
  data () {
    return {
      isLoading: false,
      hubLoading:'',
      hubid: "",
      fromdate: '',
			todate: '',
      hubdetailsarray: [],
      DestHubNameData: [],
      HubNameData:[],
      DlinkError:"",
      displayDlinkError:false
    }
  },
  computed: {},
  filters: {
    moment: function(date) {
			if (date == null || date == '')
				return '--'
			return moment(date).format('DD-MM-YYYY HH:mm:ss');
		},
  },
  mounted () {
    this.getHubName();
  },
  methods: {
    dateFormat(date) {
			return moment(date).format('YYYY-MM-DD');
		},
    dlinkReport() {
      this.isLoading = true
      var self = this
      this.input = {}
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getDlinkReport?fromDate='+ this.fromdate.toISOString() + '&toDate=' + this.todate.toISOString() + '&processLocation='+this.hubid,
          'data': this.input,
          headers: {
            //'Accept':'application/json',
            'authorization': "authkey xB84JJ89Hd25"
            //'Postman-Token':'a13610fd-a46f-4f06-a24c-409889e6eb14'
          }
        })
        .then(result => {
          this.isLoading = false
          if (result.data.ResultCode == 100) {
            this.$alertify.success(result.data.ReturnMessage)
            this.DlinkError=result.data;
            this.displayDlinkError=true
          } else {
            this.$alertify.error(result.data.ReturnMessage)
            this.displayDlinkError=false
          }
        }, error => {
          console.error(error)
          this.isLoading = false
        })
    },
    onSubmit: function() {
			this.$validator.validateAll()
				.then((result) => {
					if (!result) {
						return false;
					} else {
						this.dlinkReport();
					}
				}).catch((err) => {
					console.log('errors exist',err);
				});
		},
    reset() {
			this.fromdate = '';
      this.todate='';
      this.hubid='';
      this.DlinkError='';
      this.displayDlinkError=false
      this.$validator.reset()
		},
    downloadDlinkReport(errorvalue) {
      this.isLoading = true
      var self = this
      this.input = {}
     axios({
         method: 'GET',
         'url': apiUrl.api_url_hubops + 'downloadDlinkReport?fromDate='+ this.fromdate.toISOString() + '&toDate=' + this.todate.toISOString() + '&processLocation='+this.hubid +'&errorType='+errorvalue,
         'data': this.input,
         'headers': {
           'authorization': 'authkey xB84JJ89Hd25',
         }
       })
       .then(result => {
         if (result.data.ResultCode == 100) {
           this.isLoading = false
           let expArr = result.data.ResponseData.map(i => ({ ShippingId:i.ShippingId,BagNo:i.BagNo, ReturnMessage:i.Response.ReturnMessage, CreatedDate:moment(i.CreatedDate).format('YYYY-MM-DD HH:mm:ss'), ProcessLocation:i.ProcessLocation }));

           this.csvFields = {
             'ShippingId': 'ShippingId',
             'BagNo': 'BagNo',
             'ReturnMessage': 'Reason',
             'CreatedDate': 'CreatedDate',
             'ProcessLocation':'ProcessLocation'
           }
           this.jsonToCSV('DlinkReport_', expArr, this.csvFields);
         }
         else if(result.data.ReturnCode !== 100){
           this.isLoading = false
           this.$alertify.success(result.data.ReturnMessage)
         }
       }, error => {
         console.error(error)
       })
   },
   jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
    var csvData = ''
    //Header
    if (this.title != null) {
      csvData += this.parseExtraData(this.title, '${data}\r\n')
    }
    //Fields
    for (let key in data[0]) {
      if (skipFilter.indexOf(key) == -1)
        csvData += csvfield[key] + ','
    }
    csvData = csvData.slice(0, csvData.length - 1)
    csvData += '\r\n'
    //Data
    data.map(function(item) {
      for (let key in item) {
        if (skipFilter.indexOf(key) == -1) {
          var escapedCSV = item[key] + '' // cast Numbers to string
          if (escapedCSV.match(/[,"\n]/)) {
            escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
          }
          if (escapedCSV == 'null')
            csvData += ',';
          else {
            if (dateFilder.indexOf(key) != -1)
              csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
            else
              csvData += escapedCSV + ','
          }
        }
      }
      csvData = csvData.slice(0, csvData.length - 1)
      csvData += '\r\n'
    })
    //Footer
    if (this.footer != null) {
      csvData += this.parseExtraData(this.footer, '${data}\r\n')
    }
    filename += moment().format('DD-MM-YYYY') + '.csv';
    return this.export(csvData, filename, "application/csv");
    return csvData
  },
  export (data, filename, mime) {
   let blob = this.base64ToBlob(data, mime)
   download(blob, filename, mime)
 },

  base64ToBlob(data, mime) {
   let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
   let bstr = atob(base64)
   let n = bstr.length
   let u8arr = new Uint8ClampedArray(n)
   while (n--) {
     u8arr[n] = bstr.charCodeAt(n)
   }
   return new Blob([u8arr], {
     type: mime
   })
 },
    getHubName() {
      this.hubLoading = 'Loading Hub...'
      var i = 0;
      var self = this
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/list',
          // 'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          var HubNameData = result.data.ResponseData
          this.hubdetailsarray = result.data.ResponseData
          for (i = 0; i < HubNameData.length; i++) {
            this.DestHubNameData.push({
              value: HubNameData[i].HubID,
              text: HubNameData[i].HubName + ' (' + HubNameData[i].HubID + ')'
            })
            this.HubNameData = this.DestHubNameData
          }
        }, error => {
          console.error(error)
        })
    },

  }
}



// WEBPACK FOOTER //
// ./src/views/components/DlinkReport/DlinkReport.js